type Props = {
  intervals: readonly number[];
  value: number;
  onChange: (weeks: number) => void;
  /** Id van de kop die de keuze benoemt. */
  labelledBy: string;
  describedBy?: string;
  /** Kleiner, voor in de winkelmand. */
  compact?: boolean;
};

/**
 * Het ritme van bijvullen als rij keuzes ("Elke 8 weken"). Eén vorm voor Mijn omgeving, de
 * samensteller en de winkelmand, zodat een keuze er overal hetzelfde uitziet.
 */
export function IntervalChoice({
  intervals,
  value,
  onChange,
  labelledBy,
  describedBy,
  compact = false
}: Props) {
  return <div role="group" aria-labelledby={labelledBy} aria-describedby={describedBy} className="flex flex-wrap gap-1.5" data-id="element-8734" data-mp="1231bq668jdoc">
      {intervals.map(w => {
      const on = value === w;
      return <button key={w} type="button" aria-pressed={on} onClick={() => !on && onChange(w)} className={`whitespace-nowrap rounded-full tabular-nums transition-[background-color,color,box-shadow] duration-150 ease-soft ${compact ? 'px-3 py-2 text-[12px]' : 'px-3.5 py-2.5 text-[13px]'} ${on ? 'bg-ink text-shell' : 'text-ink ring-1 ring-line hover:ring-ink/40'}`} data-id="element-8735" data-mp="t0iec1l7xt9h">
            {compact ? `${w} weken` : `Elke ${w} weken`}
          </button>;
    })}
    </div>;
}